export default __webpack_public_path__ + "static/media/Exclamação Triangulo.1fc47ef6.svg";